// Maak van een hex een rgb.
function hex2rgb(hex: string) {
    let hexString: string = hex.substr(1).toString();
    let rgb = "rgb(" + parseInt(hexString.substr(0, 2), 16) + "," + parseInt(hexString.substr(2, 2), 16) + "," + parseInt(hexString.substr(4, 2), 16) + ")";
    return rgb
}

// Geeft een contrastkleur terug op basis van de opgegeven kleur (in rgb formaat of als hex; bij rgba wordt bij alpha alleen de waarde 0 en 1 ondersteund).
// Indien de opgegeven rgb null is, wordt de defaultColor teruggegeven.
// Indien de opgegeven defaultColor niet opgegeven is, wordt "rgb(0,0,0)" teruggegeven.
export function getContrastColor(kleur: string, light?: string, dark?: string) {
    let _dark = dark || "rgb(0,0,0)";
    let _light = light || "rgb(255,255,255)";

    if (_dark.charAt(0) === '#') {
        _dark = hex2rgb(_dark);
    }

    if (kleur && kleur !== "transparent") {
        if (kleur.charAt(0) === '#') {
            kleur = hex2rgb(kleur);
        }

        if (_light.charAt(0) === '#') {
            _light = hex2rgb(_light);
        }

        let rgbArray = kleur.match(/\d+/g);
        if (rgbArray === null) {
            return _dark;
        }
        let transparent = rgbArray.length === 4 && rgbArray[3] === "0";

        // Link: http://stackoverflow.com/a/11868159
        let o = Math.round(((parseInt(rgbArray[0]) * 299) + (parseInt(rgbArray[1]) * 587) + (parseInt(rgbArray[2]) * 114)) / 1000);

        return (transparent || o > 125) ? _dark : _light;
    } else {
        return _dark;
    }
}